import {gql} from '@apollo/client'

export const CREATE_UPDATE_TRANSPORT = gql`
  mutation transportCreateUpdate($input: TransportCreateUpdateInput!) {
    transportCreateUpdate(input: $input) {
      errors {
        field
        messages
      }
      transport {
        id
      }
    }
  }
`
